export default "/images/check.svg?48c9302a6399f1624510566d3697974c";